import { commonApi, apiName } from './config.js';
import app from './public.js';
import h5Copy from './junyi-h5-copy.js';
import DateTool from './DateTool.js';
import mdate from './momentHandle.js';
import * as dd from 'dingtalk-jsapi';
import { refConfig } from './config/refConfig.js';
import store from '@/store/index.js';
import Sensors from '@/js_sdk/Sensorsdata';

let defaultCustomerIndexResult = {
  Code: '0000',
  Msg: '',
  Data: {
    Enterprise: {
      EnterpriseId: 0,
      EnterpriseName: '',
      IsTrial: false,
      IsUploadTravelBusinessCertify: false,
      IsCanValidateBill: true,
      AccountBalance: 0.1,
      IsExpiredContract: false,
      IsDingQiYeWX: true,
      DebitType: 1,
      CanSupplierMemberContrast: true,
      CanSupplierMemberContrasts: [
        {
          SupplierType: 2,
          CanSupplierMemberContrast: true,
          IsSupportBindingMember: false,
        },
        {
          SupplierType: 10,
          CanSupplierMemberContrast: false,
          IsSupportBindingMember: false,
        },
        {
          SupplierType: 13,
          CanSupplierMemberContrast: true,
          IsSupportBindingMember: true,
        },
      ],
      ExpiredContent: '贵司合同已到期,暂时无法使用,请联系管理员续约',
      ContractCenewalContact: '18896588142',
      IsUserNewExpense: false,
    },
    Customer: {
      CustomerName: '',
      IsManage: false,
      IsApprover: true,
      IsFinancial: false,
      PermittedBook: {
        Hotel: true,
        InternationalHotel: true,
        Flight: true,
        InternationalFlight: true,
        Train: true,
        Car: true,
        CarWork: true,
        CarTemp: true,
        Waimai: true,
        WaimaiWork: true,
        WaimaiOther: true,
        HotelDays: 0,
        FlightDays: 0,
        NeedTravelForm: 0,
      },
      IsCeekeeTravelStandard: true,
      IsSupplierMemberContrast: false,
      IsSupplierMemberContrasts: [
        {
          SupplierType: 2,
          IsSupplierMemberContrast: false,
        },
        {
          SupplierType: 13,
          IsSupplierMemberContrast: false,
        },
        {
          SupplierType: 10,
          IsSupplierMemberContrast: false,
        },
      ],
      IsHasPhone: true,
      MobileNumberMsg: null,
    },
  },
};

function getCustomerIndex(callback) {
  let param = {};
  let settings = app.GetSettings();
  if (settings.ProcessInstanceId && settings.RefId != 154) {
    param.ExternalId = settings.ProcessInstanceId;
  }
  GetEnterpriseKey();
  app.Post(
    commonApi.GetCustomerIndexInfo,
    param,
    (data) => {
      const result = data.Data;
      Sensors.update_profile({
        MemberName: result.Customer.CustomerName,
        EnterpriseId: result.Enterprise.EnterpriseId,
        CompanyName: result.Enterprise.EnterpriseName,
      });
      handleCustomerIndexResult(data, callback);
    },
    null,
    true,
  );
}

function initCustomerPermitted() {
  let settings = app.GetSettings();
  settings.IsPermittedUseCar = true;
  settings.IsPermittedUseCarTemp = true;
  settings.IsPermittedUseCarWork = true;
  settings.IsPermittedBookHotel = true;
  settings.IsPermittedBookInternationalHotel = true;
  settings.IsPermittedBookFlight = true;
  settings.IsPermittedBookTrain = true;
  settings.IsPermittedBookInternationalFlight = true;
  app.SetSettings(settings);
}

function handleCustomerIndexResult(data, callback) {
  if (app.GetResultState(data)) {
    let settings = app.GetSettings();
    var result = data.Data;
    let companyName = result.Enterprise.EnterpriseName;
    let enterpriseId = result.Enterprise.EnterpriseId;
    let isTrial = result.Enterprise.IsTrial;
    let isManage = result.Customer.IsManage;
    app.CustomerJurisdiction.CanUse = true;
    app.CustomerJurisdiction.IsPermittedUseCar = result.Customer.PermittedBook.Car;
    app.CustomerJurisdiction.IsPermittedUseCarTemp = result.Customer.PermittedBook.CarTemp;
    app.CustomerJurisdiction.IsPermittedUseCarWork = result.Customer.PermittedBook.CarWork;
    app.CustomerJurisdiction.IsPermittedBookHotel = result.Customer.PermittedBook.Hotel;
    app.CustomerJurisdiction.IsPermittedBookInternationalHotel = result.Customer.PermittedBook.InternationalHotel;
    app.CustomerJurisdiction.IsPermittedBookFlight = result.Customer.PermittedBook.Flight;
    app.CustomerJurisdiction.IsPermittedBookTrain = result.Customer.PermittedBook.Train;
    app.CustomerJurisdiction.IsPermittedBookInternationalFlight = result.Customer.PermittedBook.InternationalFlight;
    app.CustomerJurisdiction.IsCanValidateBill = result.Enterprise.IsCanValidateBill;
    app.CustomerJurisdiction.AccountBalance = result.Enterprise.AccountBalance;
    app.MemberInfo.MemberName = result.Customer.CustomerName;
    app.CustomerJurisdiction.IsUploadTravelBusinessCertify = result.Customer.IsUploadTravelBusinessCertify || false;
    app.CustomerJurisdiction.IsManage = isManage ? 1 : 0;
    app.CustomerJurisdiction.IsTrial = isTrial;

    settings.IsTrial = false;
    settings.isLogin = true;
    settings.IsManage = isManage ? 1 : 0;
    settings.CompanyName = companyName;
    settings.IsHasPhone = result.Customer.IsHasPhone;
    settings.IsApprover = result.Customer.IsApprover;
    settings.IsPermittedUseCar = result.Customer.PermittedBook.Car;
    settings.IsPermittedUseCarTemp = result.Customer.PermittedBook.CarTemp;
    settings.IsPermittedUseCarWork = result.Customer.PermittedBook.CarWork;
    settings.IsPermittedBookHotel = result.Customer.PermittedBook.Hotel;
    settings.IsPermittedBookInternationalHotel = result.Customer.PermittedBook.InternationalHotel;
    settings.IsPermittedBookFlight = result.Customer.PermittedBook.Flight;
    settings.IsPermittedBookTrain = result.Customer.PermittedBook.Train;
    settings.IsPermittedBookInternationalFlight = result.Customer.PermittedBook.InternationalFlight;
    settings.IsUploadTravelBusinessCertify = result.Customer.IsUploadTravelBusinessCertify || false;
    settings.IsCanValidateBill = result.Enterprise.IsCanValidateBill;

    settings.FlightCanNotBookingMsg = result.Customer.PermittedBook.FlightCanNotBookingMsg || '';
    settings.CarCanNotBookingMsg = result.Customer.PermittedBook.CarCanNotBookingMsg || '';
    settings.HotelCanNotBookingMsg = result.Customer.PermittedBook.HotelCanNotBookingMsg || '';
    settings.InternationalHotelCanNotBookingMsg =
      result.Customer.PermittedBook.InternationalHotelCanNotBookingMsg || '';
    settings.InternationalFlightCanNotBookingMsg =
      result.Customer.PermittedBook.InternationalFlightCanNotBookingMsg || '';
    settings.TrainCanNotBookingMsg = result.Customer.PermittedBook.TrainCanNotBookingMsg || '';
    settings.WaimaiCanNotBookingMsg = result.Customer.PermittedBook.WaimaiCanNotBookingMsg || '';
    settings.takeoutPeritted = {
      IsPermittedUseWork: result.Customer.PermittedBook.WaimaiWork || false, //加班
      IsPermittedUse: result.Customer.PermittedBook.Waimai || false, //出差
      IsPermittedUseTemp: result.Customer.PermittedBook.WaimaiOther || false, //其它
    };
    settings.DebitType = result.Enterprise.DebitType || 0;
    settings.AccountBalance = result.Enterprise.AccountBalance;
    (settings.MemberInfo || {}).CustomerName = result.Customer.CustomerName;
    (settings.MemberInfo || {}).MemberName = result.Customer.CustomerName;
    (settings.MemberInfo || {}).EnterpriseId = enterpriseId;
    settings.MemberName = result.Customer.CustomerName;
    settings.HotelAdvanceDay = result.Customer.PermittedBook.HotelDays || 0;
    settings.FlightAdvanceDay = result.Customer.PermittedBook.FlightDays || 0;
    settings.IsExpiredContract = result.Enterprise.IsExpiredContract;
    settings.ExpiredContent = result.Enterprise.ExpiredContent;
    settings.IsCeekeeTravelStandard = result.Customer.IsCeekeeTravelStandard;
    settings.CustomerNeedTravelForm = result.Customer.PermittedBook.NeedTravelForm;
    settings.ContractCenewalContact = result.Enterprise.ContractCenewalContact;
    settings.needTravelForm = result.Customer.PermittedBook.NeedTravelForm;
    settings.IsUserNewExpense = result.Enterprise.IsUserNewExpense;
    settings.IsNeedTravelBusinessOrderBefore = result.Customer.PermittedBook.IsNeedTravelBusinessOrderBefore || 0;
    app.SetSettings(settings);
    store.commit('common/setNeedTravelFormVuex', result.Customer.PermittedBook.NeedTravelForm);
  } else {
    //setCustomerNull(data);
  }

  if (callback) {
    callback(data);
  }
}

//获取企业KEY
function GetEnterpriseKey() {
  app.Post(
    commonApi.GetPublicConfigure,
    {},
    (data) => {
      if (app.GetResultState(data)) {
        let settings = app.GetSettings();
        settings.EnterpriseKey = (data.Data || {}).GrayGroupName || '';
        app.SetSettings(settings);
      }
    },
    null,
    true,
  );
}

function checkLogin(path) {
  let settings = app.GetSettings();
  if (settings.isLogin) {
    uni.navigateTo({
      url: path,
    });
  } else {
    uni.navigateTo({
      url: '/pages/loginAndRegister/login/login',
    });
  }
}

function customerCopy(url) {

  const result = h5Copy(url);
  if (result === false) {
    app.Toast('复制失败');
  } else {
    app.Toast('复制成功');
  }












}

function validateBooking(advanceDay, checkDay, productType) {
  return true;
}

function setMemberId(data, enterpriseId) {
  let settings = app.GetSettings();
  let customers = settings.Customers || [];
  let entity = customers.find((x) => x.EnterpriseId == enterpriseId);
  if (entity) {
    data.MemberId = entity.MemberId;
    data.Token = entity.Token;
  }
  return data;
}

function getPublicConfig(key) {
  let settings = app.GetSettings();
  let promise = new Promise((resolve, reject) => {
    if (settings.EnterpriseId) {
      app.Post(
        apiName.GetPublicConfigValue,
        {
          Key: key,
        },
        (res) => {
          if (app.GetResultState(res)) {
            resolve(res.Value);
          }
          resolve('');
        },
        null,
        true,
      );
    } else {
      resolve('');
    }
  });
  return promise;
}

function isPlatformDistribution() {
  // 是否神州浩天
  let settings = app.GetSettings();
  if (settings.RefId && settings.RefId > 0) {
    return settings.RefId;
  }
  return 0;
}

//一键登录
//param 登录参数  customerIndexCallback 获取用户信息回调方法
function temporaryCodeLogin(param, customerIndexCallback, loginErrorCallback, notGetDetail) {
  // app.Loading('登录中...');
  app.Post(apiName.Login, param, (data) => {
    let settings = app.GetSettings();
    if (app.GetResultState(data)) {
      settings.Customers = data.Customers || [];
      app.MemberInfo.EnterpriseId = data.Customers[0].EnterpriseId || 0;
      app.MemberInfo.MemberId = data.Customers[0].MemberId;
      app.MemberInfo.Token = data.Customers[0].Token;
      app.MemberInfo.isLogin = true;
      settings.MemberInfo = app.MemberInfo;
      settings.isLogin = true;
      settings.MemberName = data.Customers[0].MemberName;
      settings.CompanyName = data.Customers[0].EnterpriseName;
      app.SetSettings(settings);
      Sensors.login(data.Customers[0]);
      initCustomerPermitted();
      if (settings.RefId == refConfig.dingdingjijian) {
        handleCustomerIndexResult(defaultCustomerIndexResult, customerIndexCallback);
      } else {
        if (notGetDetail) {
          if (customerIndexCallback) {
            customerIndexCallback();
          }
        } else {
          app.Loading();
          getCustomerIndex(customerIndexCallback);
        }
      }
    } else {
      if ((data.Msg || '') == '人员正在授权中，请稍后再试') {
        uni.redirectTo({
          url: '/pages/index2.0/signError',
        });
      } else {
        if (data.Code == '2000' && loginErrorCallback) {
          loginErrorCallback(data.Msg);
        }
        let code = app.GetQueryString('code') || '';
        if (code) {
          if (customerIndexCallback) {
            customerIndexCallback(data.Msg);
          }
        }
        app.MemberInfo.isLogin = false;
        settings.isLogin = false;
        settings.MemberInfo = app.MemberInfo;
        settings.TmpAuthCode = '';
        app.SetSettings(settings);
      }
    }
  });
}

export default {
  getCustomerIndex,
  checkLogin,
  customerCopy,
  validateBooking,
  setMemberId,
  isPlatformDistribution,
  GetEnterpriseKey,
  temporaryCodeLogin,
  initCustomerPermitted,
};
